module.exports = __webpack_public_path__ + "static/media/12.d3d8cb8c.jpg";